<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif; background: #f4f6f9; min-height: 100vh;">
    <div class="max-w-7xl mx-auto px-4 pt-24 pb-6">
      
      <!-- HEADER -->
      <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div>
          <h1 class="text-2xl font-black text-slate-800 uppercase tracking-tight">Licitações</h1>
          <p class="text-[10px] text-slate-400 font-bold uppercase tracking-widest">Gestão de processos licitatórios e certames</p>
        </div>
        <div class="flex items-center gap-3">
          <button @click="$router.push('/biddings-manager/create')" class="bg-[#f37021] hover:bg-orange-600 active:scale-95 text-white font-bold text-[11px] uppercase tracking-widest px-6 h-12 rounded-lg shadow-sm transition-all flex items-center gap-2">
            <v-icon size="16" color="white">mdi-plus</v-icon>
            <span>Nova Licitação</span>
          </button>
        </div>
      </div>

      <div class="space-y-6 pb-24">
        
        <!-- FILTROS -->
        <section class="bg-white rounded-xl overflow-hidden shadow-sm border border-slate-100">
          <div class="px-6 py-3 flex items-center gap-3" style="background-color: #333333;">
            <v-icon color="orange" small>mdi-filter-variant</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">Refinar Listagem</h2>
          </div>
          
          <div class="p-6">
            <v-row dense align="end">
              <v-col cols="12" md="3">
                <label class="field-label">DATA INICIAL</label>
                <v-menu
                  v-model="menuStart"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.startDateFormatted"
                      placeholder="DD/MM/AAAA"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined dense hide-details
                      class="field-input"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="filter.startDate"
                    @input="menuStart = false"
                    no-title
                    scrollable
                    locale="pt-br"
                    color="orange"
                  />
                </v-menu>
              </v-col>
              <v-col cols="12" md="3">
                <label class="field-label">DATA FINAL</label>
                <v-menu
                  v-model="menuEnd"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.endDateFormatted"
                      placeholder="DD/MM/AAAA"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined dense hide-details
                      class="field-input"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="filter.endDate"
                    @input="menuEnd = false"
                    no-title
                    scrollable
                    locale="pt-br"
                    color="orange"
                  />
                </v-menu>
              </v-col>
              <v-col cols="12" md="4">
                <label class="field-label">MUNICÍPIO</label>
                <v-autocomplete
                  v-model="filter.prefecture_id"
                  :items="prefectures"
                  item-text="prefecture_social_name"
                  item-value="prefecture_id"
                  placeholder="TODOS OS MUNICÍPIOS"
                  outlined dense hide-details
                  class="field-input"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="2">
                <button @click="initialize" class="w-full bg-[#333333] hover:bg-slate-900 text-white font-bold text-[10px] uppercase tracking-widest h-[42px] rounded-lg transition-all flex items-center justify-center gap-2">
                  <v-icon color="orange" size="14">mdi-filter</v-icon>
                  FILTRAR
                </button>
              </v-col>
            </v-row>
          </div>
        </section>

        <!-- LISTAGEM -->
        <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
            <div style="background-color: #333333; display: flex; align-items: center; padding: 10px 20px; width: 100%; box-sizing: border-box;">
                <div style="display: flex; align-items: center; gap: 8px; flex-shrink: 0;">
                  <v-icon color="orange" small>mdi-file-document-multiple</v-icon>
                  <span style="color: white; font-weight: 700; font-size: 11px; text-transform: uppercase; letter-spacing: 0.1em;">PROCESSOS LICITATÓRIOS</span>
                </div>
                
                <div style="margin-left: auto; display: flex; align-items: center; gap: 12px; flex-shrink: 0; width: 300px;">
                  <v-text-field
                    v-model="search"
                    placeholder="PESQUISAR..."
                    outlined dense hide-details
                    class="field-input-dark w-full"
                    prepend-inner-icon="mdi-magnify"
                  />
                </div>
            </div>

            <div class="overflow-x-auto">
                <v-data-table
                  :headers="headers"
                  :items="filteredData"
                  :search="search"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  :loading="loader"
                  loading-text="Sincronizando processos..."
                  class="custom-table"
                  hide-default-footer
                >
                  <template v-slot:item.bidding_id="{ item }">
                    <span class="text-[10px] font-bold text-slate-400 font-mono tracking-widest bg-slate-50 px-2 py-0.5 rounded border border-slate-100">#{{ item.bidding_id }}</span>
                  </template>

                  <template v-slot:item.prefecture_social_name="{ item }">
                    <div class="flex flex-col py-2">
                      <span class="text-xs font-bold text-slate-700 uppercase">{{ item.prefecture_social_name }}</span>
                      <span class="text-[9px] font-bold text-slate-400 uppercase tracking-widest mt-0.5">{{ item.bidding_process_number || 'S/N' }}</span>
                    </div>
                  </template>

                  <template v-slot:item.modality_desc="{ item }">
                    <span class="px-2 py-0.5 rounded bg-slate-50 border border-slate-100 text-[9px] font-bold text-slate-500 uppercase tracking-widest">
                      {{ item.modality_desc }}
                    </span>
                  </template>

                  <template v-slot:item.type_desc="{ item }">
                    <span class="text-[10px] font-bold text-slate-600 uppercase">{{ item.type_desc }}</span>
                  </template>

                  <template v-slot:item.bidding_status="{ item }">
                    <div class="flex items-center gap-2">
                      <div :class="['w-1.5 h-1.5 rounded-full', item.bidding_status ? 'bg-emerald-500' : 'bg-rose-500']"></div>
                      <span :class="['text-[9px] font-bold uppercase tracking-widest', item.bidding_status ? 'text-emerald-600' : 'text-rose-600']">
                        {{ item.bidding_status ? 'Ativa' : 'Inativa' }}
                      </span>
                    </div>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <div class="flex justify-end gap-1 px-2">
                      <button @click="$router.push(`/biddings-manager/edit/${item.bidding_id}`)" class="p-2 hover:bg-orange-50 text-orange-600 rounded-lg transition-colors" title="Editar">
                        <v-icon small color="orange">mdi-pencil</v-icon>
                      </button>
                      <button @click="deleteItem(item.bidding_id)" class="p-2 hover:bg-red-50 text-red-600 rounded-lg transition-colors" title="Excluir">
                        <v-icon small color="red">mdi-delete</v-icon>
                      </button>
                    </div>
                  </template>

                  <template v-slot:no-data>
                    <div class="py-12 flex flex-col items-center justify-center text-slate-400">
                      <v-icon size="48" color="slate-100">mdi-file-search-outline</v-icon>
                      <p class="mt-2 text-[10px] font-bold uppercase tracking-widest">Nenhuma licitação encontrada</p>
                    </div>
                  </template>
                </v-data-table>

                <!-- Custom Pagination Footer -->
                <div class="bg-slate-50 px-6 py-6 border-t border-slate-100 flex flex-col items-center justify-center gap-4 text-[10px] text-slate-400 font-bold uppercase tracking-widest">
                    <span>Exibindo {{ paginationStart }} de {{ filteredData.length }} registros</span>
                    
                    <div class="flex gap-2" v-if="pageCount > 1">
                        <button 
                          @click="page > 1 ? page-- : null" 
                          :disabled="page === 1"
                          class="px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-100 disabled:opacity-50 transition-all"
                        >
                          Anterior
                        </button>
                        
                        <button 
                          v-for="p in visiblePages" 
                          :key="p"
                          @click="page = p"
                          :class="p === page ? 'bg-slate-700 text-white shadow-sm' : 'bg-white border-slate-200 hover:bg-slate-100'"
                          class="w-8 h-8 border rounded-lg transition-all flex items-center justify-center"
                        >
                          {{ p }}
                        </button>
 
                        <button 
                          @click="page < pageCount ? page++ : null" 
                          :disabled="page === pageCount"
                          class="px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-100 disabled:opacity-50 transition-all"
                        >
                          Próximo
                        </button>
                    </div>
                </div>
            </div>
        </section>
      </div>

      <!-- NOTIFICAÇÕES -->
      <v-snackbar v-model="snack.show" :color="snack.color" timeout="4000" top elevation="24" class="custom-snack">
        <div class="flex items-center gap-3">
          <v-icon color="white" small>{{ snack.color === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
          <span class="text-xs font-bold uppercase tracking-widest">{{ snack.message }}</span>
        </div>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      loader: true,
      data: [],
      prefectures: [],
      filter: { 
        startDate: null, 
        startDateFormatted: null,
        endDate: null, 
        endDateFormatted: null,
        prefecture_id: null 
      },
      menuStart: false,
      menuEnd: false,
      snack: { show: false, message: "", color: "" },
      headers: [
        { text: "CÓDIGO", value: "bidding_id", sortable: true, width: "100px" },
        { text: "PREFEITURA / PROCESSO", value: "prefecture_social_name", sortable: true },
        { text: "MODALIDADE", value: "modality_desc", sortable: true },
        { text: "TIPO", value: "type_desc", sortable: true },
        { text: "STATUS", value: "bidding_status", sortable: true, align: "left" },
        { text: "AÇÕES", align: "right", value: "action", sortable: false }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  computed: {
    filteredData() {
      let filtered = this.data;
      if (this.filter.prefecture_id) filtered = filtered.filter(item => item.prefecture_id === this.filter.prefecture_id);
      return filtered;
    },
    paginationStart() {
      return this.filteredData.length > 0 ? (this.page - 1) * this.itemsPerPage + 1 : 0;
    },
    visiblePages() {
      const pages = [];
      const totalVisible = 5;
      let start = Math.max(1, this.page - Math.floor(totalVisible / 2));
      let end = Math.min(this.pageCount, start + totalVisible - 1);
      if (end - start + 1 < totalVisible) start = Math.max(1, end - totalVisible + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    }
  },
  watch: {
    'filter.startDate'(val) {
      this.filter.startDateFormatted = this.formatDate(val);
    },
    'filter.endDate'(val) {
      this.filter.endDateFormatted = this.formatDate(val);
    }
  },
  created() {
    this.getPrefectures();
    this.initialize();
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    getPrefectures() {
      this.$http.get("/prefectures").then(r => this.prefectures = r.data);
    },
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", true);
      let params = {};
      if (this.filter.startDate) params.startDate = this.filter.startDate;
      if (this.filter.endDate) params.endDate = this.filter.endDate;
      if (this.filter.prefecture_id) params.prefecture_id = this.filter.prefecture_id;
      this.$http.get("/biddings", { params }).then(r => {
        this.data = r.data; this.loader = false; this.$store.dispatch("setLoader", false);
      }).catch(e => {
        this.loader = false; this.snack.show = true; this.snack.message = e.message; this.snack.color = "error"; this.$store.dispatch("setLoader", false);
      });
    },
    deleteItem(id) {
      if (confirm("Deseja realmente excluir esta licitação?")) {
        this.$store.dispatch("setLoader", true);
        this.$http.delete(`/biddings/${id}`).then(r => {
          this.snack.show = true; this.snack.message = r.data.result || "Removido!"; this.snack.color = "success"; this.initialize();
        }).catch(e => {
          this.snack.show = true; this.snack.message = e.message; this.snack.color = "error"; this.$store.dispatch("setLoader", false);
        });
      }
    }
  }
};
</script>

<style scoped>
.field-label {
  display: block;
  font-size: 9px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 4px;
}

.field-input >>> .v-input__control .v-input__slot {
  background-color: #f8fafc !important;
  border-radius: 6px !important;
}

.field-input >>> .v-input__control .v-input__slot fieldset {
  border-color: #e2e8f0 !important;
  border-width: 1px !important;
}

.field-input >>> .v-input__control .v-input__slot:hover fieldset {
  border-color: #f37021 !important;
}

.field-input >>> input {
  font-size: 13px !important;
  color: #334155 !important;
}

.field-input-dark >>> .v-input__control .v-input__slot {
  background-color: #333333 !important;
  border-radius: 6px !important;
}

.field-input-dark >>> .v-input__control .v-input__slot fieldset {
  border-color: #444444 !important;
}

.field-input-dark >>> input {
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 11px !important;
  text-transform: uppercase !important;
}

.custom-table ::v-deep table { background-color: transparent !important; border-collapse: separate; border-spacing: 0; }
.custom-table ::v-deep th { 
  color: #94a3b8 !important; 
  font-weight: 700 !important; 
  text-transform: uppercase !important; 
  font-size: 10px !important; 
  letter-spacing: 0.05em !important;
  background-color: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0 !important;
  height: 48px !important;
}
.custom-table ::v-deep td { 
  border-bottom: 1px solid #f1f5f9 !important;
  color: #334155 !important;
  font-size: 13px !important;
}

.custom-snack >>> .v-snack__wrapper {
  border-radius: 10px !important;
}
</style>